import PropTypes from "prop-types";

import React, { lazy } from "react";

const MemoizedCardProduct = lazy(() =>
    import(
        "@components/OrderTaking/Components/Products/ProductWrapper/CardProduct"
    )
);

export function ResponsiveItemsList({
    visibleItems,
    currentWorkflow,
    orderItems,
    isWorkFlow,
    gridSystem,
    workflowData,
    orderWorkflowItemSlice,
    scrollableParentRef,
    lastElementRef,
}) {
    const { nbrColumn, nbrRows } = gridSystem;
    let nbItem = nbrColumn * nbrRows;

    const scrollToTop = () => {
        scrollableParentRef.current &&
            scrollableParentRef.current.scrollTo(0, 0);
    };

    React.useEffect(() => {
        scrollToTop();
    }, []);

    function getList(startIndex, endIndex) {
        return (
            <div
                key={startIndex}
                style={{
                    display: "grid",
                    gridTemplateColumns: `repeat(${nbrColumn},${1}fr)`,
                    gridTemplateRows: `repeat(${nbrRows}, 1fr)`,
                    columnGap:
                        nbrColumn === 2
                            ? "35px"
                            : isWorkFlow
                            ? "20px"
                            : `${12 - 2 * nbrColumn}px`,
                    rowGap: `${12 - 2 * nbrColumn}px`,
                    minHeight: "98%",
                    marginBottom: "10px",
                    marginTop: "10px",
                    justifyContent: "space-evenly",
                }}
            >
                {visibleItems.slice(startIndex, endIndex).map((product) => {
                    return (
                        <div
                            key={product?.iuud}
                            className="product-card"
                            ref={
                                visibleItems.length === endIndex
                                    ? lastElementRef
                                    : null
                            }
                        >
                            <MemoizedCardProduct
                                product={product}
                                currentWorkflow={currentWorkflow}
                                orderItems={orderItems}
                                workflowData={workflowData}
                                orderWorkflowItemSlice={orderWorkflowItemSlice}
                            />
                        </div>
                    );
                })}
            </div>
        );
    }

    function getBloc() {
        const totalItems = visibleItems.length;

        const grids = [];

        for (let nb = 0; nb < totalItems; nb += nbItem) {
            const endIdx = Math.min(nb + nbItem, totalItems);

            grids.push(getList(nb, endIdx, grids));
        }

        return grids;
    }
    const itemsToView = getBloc();

    return itemsToView;
}
ResponsiveItemsList.propTypes = {
    currentWorkflow: PropTypes.object,
    visibleItems: PropTypes.array,
    orderItems: PropTypes.array,
    isWorkFlow: PropTypes.bool,
    gridSystem: PropTypes.object,
    workflowData: PropTypes.array,
    orderWorkflowItemSlice: PropTypes.object,
    scrollableParentRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any }),
    ]),
    lastElementRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any }),
    ]),
};
